import { institutionsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewInstitution = (state = initialState, action) => {
  switch (action.type) {
    case institutionsConstants.VIEW_INSTITUTION_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case institutionsConstants.VIEW_INSTITUTION_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case institutionsConstants.VIEW_INSTITUTION_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case institutionsConstants.VIEW_INSTITUTION_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
